module.exports = {
      id: "comm-automobile-usage",
      viewBox: "0 0 231.941 38.7",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#comm-automobile",
      toString: function () {
        return this.url;
      }
    }